import { createUseCategoryDetails } from '@akyga/shared-ui/useCategoryDetails';
import httpClient from 'API/httpClient';

export default createUseCategoryDetails(httpClient);
